/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class TemplatesControllerService extends DataBaseService {

  /**
   * Path part for operation templatesControllerIsTemplateUsed
   */
  static readonly TemplatesControllerIsTemplateUsedPath = '/v1/templates/{id}/used';

  /**
   * returns whether template is used or not
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `isTemplateUsed()` instead.
   *
   * This method doesn't expect any request body.
   */
  isTemplateUsed$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, TemplatesControllerService.TemplatesControllerIsTemplateUsedPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * returns whether template is used or not
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `isTemplateUsed$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  isTemplateUsed(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<boolean> {

    return this.isTemplateUsed$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

}
